import script from "./PopupInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupInfo.vue?vue&type=script&setup=true&lang=ts"

import "./PopupInfo.vue?vue&type=style&index=0&id=a508f9be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a508f9be"]])

export default __exports__